// extracted by mini-css-extract-plugin
export default {"content-root":"_2hhj-","contentRoot":"_2hhj-","title":"TsUQf","message":"mwEvO","image":"_24Toj"};